import { PropsWithChildren } from 'react'
import { styled } from 'styled-components'

const StyledSurface = styled.div`
  background-color: var(--colour-surface-brand-bold);
  border-radius: var(--radius-8);
  padding: var(--grid-16);
`

export const DSSurface = ({ children }: PropsWithChildren) => {
  return <StyledSurface>{children}</StyledSurface>
}
